const ru = {
  heading: 'UX Core',
  link: 'uxcore.io',
  description:
    'Крупнейшая бесплатная библиотека когнитивных искажений (паттернов мышления) с более чем 1000 примеров использования.',
  moto: 'Be Kind. Do Good.',
  mainTitle: 'Среда проявления искажений',
  browsingAsProduct: 'Вы смотрите примеры в категории "Разработка продуктов"',
  browsingAsHR: 'Вы смотрите примеры в категории Управление персоналом',
  browsingAsOffsec:
    'Вы смотрите примеры в категории наступательной безопасности',
  sectionTitles: [
    { color: 'purple', title: 'Когда запоминаем и вспоминаем' },
    { color: 'pink', title: 'Когда быстро реагируем' },
    { color: 'green', title: 'Когда не хватает смысла' },
    { color: 'blue', title: 'Когда много информации' },
  ],
  legends: ['Для продуктов', 'Для менеджмента'],
  explanationLink: {
    title: 'О проекте',
    link: 'https://keepsimple.io/ru/articles/what-is-ux-core',
  },
};

export default ru;
